<template>
  <a-modal :bordered="false" title="对帐单默认模版" style="top: 20px;" :width="1300" v-model="modifyible" footer="">
    <a-form layout="inline" :form="form">
      <div v-if="templatelist">
        <h1 style="text-align: center">{{templatelist.enterpriseName}} 对帐单默认模版</h1>
        <h5 style="text-align: center">市场负责人：{{templatelist.marketPrincipal}}</h5>
        <!--默认对帐单  分单-->
        <a-row>
          <template>
            <a-col :span="6"></a-col>
            <a-col :span="18">
              <div style="margin: 20px">
                <a-radio-group v-model="value" @click="onChangeradio">
                  默认对帐单 分单:
                  <a-radio :value="item.key" v-for="item in plainOptions">
                    {{item.title}}
                  </a-radio>
                </a-radio-group>
                <a-button type="primary" @click="empty()">
                  清空
                </a-button>
              </div>
              <a-transfer :data-source="statement_template_sort" :titles="['默认对帐单  排序', '']" :target-keys="targetKeys"
                :render="item => item.title" @change="statementhandleChange" @selectChange="statementhandleSelectChange"
                :list-style="{width: '300px', height: '300px',}" />
              <a-row>
                <a-col :span="15"></a-col>
                <a-col :span="6">
                  <a-button type="primary" @click="up('statement')">
                    上移
                  </a-button>
                  <a-button type="primary" style="margin: 20px" @click="down('statement')">
                    下移
                  </a-button>
                </a-col>
              </a-row>
              <a-form-item label="备注" style="margin: 20px;">
                <!--, { rules: [{ required: true, message: '请输入备注信息!' }] }-->
                <a-input  type="textarea" style="width: 580px;margin-left: 6px;" v-decorator="['seperateRemark']" />
              </a-form-item>
            </a-col>
          </template>
        </a-row>
        <!--默认对帐单  数据-->
        <a-row>
          <template>
            <a-col :span="6"></a-col>
            <a-col :span="15">
              <a-transfer :data-source="statement_template_data" :titles="['默认对帐单  数据', '默认对帐单  排序']" :target-keys="templatedatatargetKeys"
                :render="item => item.title" @change="templatedatahandleChange" @selectChange="templatedahandleSelectChange"
                :list-style="{width: '300px', height: '300px',}" />
              <a-row>
                <a-col :span="15"></a-col>
                <a-col :span="6">
                  <a-button type="primary" @click="up('templatedata')">
                    上移
                  </a-button>
                  <a-button type="primary" style="margin: 20px" @click="down('templatedata')">
                    下移
                  </a-button>
                </a-col>
              </a-row>
              <a-form-item label="备注" style="margin: 20px;">
                <!--{ rules: [{ required: true, message: '请输入备注信息!' }] }-->
                <a-input  type="textarea" style="width: 580px;margin-left: 6px;" v-decorator="['dataRemark', ]" />
              </a-form-item>
            </a-col>
          </template>
        </a-row>
        <a-row style="padding-top: 10px">
          <a-col :span="6"></a-col>
          <a-col :span="6">
            <h4>对账单接收人设置</h4>
          </a-col>
          <a-col :span="6">
            <h4>默认对帐单 排序</h4>
          </a-col>
        </a-row>
        <!--外部-->
        <a-row style="padding-top: 10px">
          <a-col :span="6"></a-col>
          <a-col :span="7">
            <a-row style=''>
              <a-col :span="9"></a-col>
              <a-col :span="3">
                <h4></h4>
              </a-col>
              <a-col :span="12" style="margin: 5px;overflow: hidden;overflow-y: scroll;border: 1px solid #ccc;width: 350px;padding: 20px;height: 300px">
                <a-row v-for="(item ,i) in leftfindId" :key="item.userId" style="padding-top: 20px">
                  <a-col :span="10">
                    <a-checkbox @change="onChangecheckbox(i,$event)" style="height: 30px">{{item.userName}}</a-checkbox>
                  </a-col>
                  <a-col :span="10">
                    <a-input v-model="item.rolename" @change="onChangeinput(i,$event)" />
                  </a-col>
                  <br />
                </a-row>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="1" style="margin-top: 74px" >
            <a-row>
              <a-button :disabled="checkedleftlist.length<=0?true:false" @click="shiftLeft">
                <a-icon type="right" style="" />
              </a-button>
            </a-row>
            <a-row>
              <a-button style="margin-top: 10px" :disabled="checkedrightlist.length<=0?true:false" @click="shiftRight">
                <a-icon type="left" />
              </a-button>
            </a-row>
          </a-col>
          <a-col :span="9">
            <a-row>
              <a-col :span="12" style="margin: 5px;overflow: hidden;overflow-y: scroll;border: 1px solid #ccc;width: 350px;padding: 20px;height:300px">
                <a-row v-for="(item ,i) in rightfindId" :key="item.userId" style="padding-top: 20px">
                  <a-col :span="10">
                    <!--:checked="item.userId==templatelist.enterpriseMajorAccount? true : false"-->
                    <!--:disabled="item.userId==templatelist.enterpriseMajorAccount? true : false "-->
                    <!--{{templatelist.enterpriseMajorAccount}}{{item.userId}}-->
                    <a-checkbox @change="onChangeright(i)"  style="height:30px" :default-checked="item.userId==templatelist.enterpriseMajorAccount? true : false" :disabled="item.userId==templatelist.enterpriseMajorAccount? true : false ">{{item.userName}}</a-checkbox>
                  </a-col>
                  <a-col :span="10">
                    <a-input disabled v-model="item.roleName" />
                  </a-col>
                  <br />
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row style="padding-top: 10px">
          <a-col :span="6"></a-col>
          <a-col :span="6">
            <a-form-item label="备注" style="margin: 20px;">
              <!--, { rules: [{ required: true, message: '请输入备注信息!' }] }-->
              <a-input  type="textarea" style="width: 580px;margin-left: 6px;" v-decorator="['receiverRemark']" />
            </a-form-item>
          </a-col>
        </a-row>
        <!--内部-->
        <a-row style="padding-top: 10px">
          <a-col :span="6"></a-col>
          <a-col :span="6">
            <h4>内部对账单接收人设置</h4>
          </a-col>
        </a-row>
        <a-row style="padding-top: 10px">
          <a-col :span="6"></a-col>
          <a-col :span="12">
            <a-row>
              <a-col :span="9"></a-col>
              <a-col :span="3">
                <h4></h4>
              </a-col>
              <a-col :span="12" style="margin: 5px;overflow: hidden;overflow-y: scroll;border: 1px solid #ccc;width: 350px;padding: 20px;height:300px">
                <div v-for="(item,i) in InternalByMenuId">
                  <a-checkbox :disabled="item.userId==templatelist.marketPrincipalId? true : false " :checked="item.checked" @change="singleonChange(i,e)">
                    {{item.userName}}
                  </a-checkbox>
                </div>
              </a-col>
              <!-- <a-checkbox-group @change="onChangegroup" v-model="checkedList" >
                  <a-row  v-for="(item ,i) in InternalByMenuId">
                    <a-col>
                      <a-checkbox :value="item.userId" :disabled="item.userId==templatelist.marketPrincipalId? true : false " checked="true"
                      >{{templatelist.marketPrincipalId}}
                          {{item.userName}} -->
              <!-- :disabled="item.userId==templatelist.marketPrincipalId? true : false " :checked="item.userId==templatelist.marketPrincipalId? true : false " -->
              <!-- </a-checkbox> -->
              <!-- </a-col> -->
              <!--   <br />
            
            </a-checkbox-group> -->
            </a-row>
          </a-col>
          <br />
        </a-row>

        <a-row style="padding-top: 10px">
          <a-col :span="9"></a-col>
          <a-col :span="6">
            <a-checkbox @change="innerFirstonChange">
              优先内部显示
            </a-checkbox>
          </a-col>
        </a-row>
        <a-row style="padding-top: 10px">
          <a-col :span="6"></a-col>
          <a-col :span="6">
            <a-form-item label="备注" style="margin: 20px;">
              <!--{ rules: [{ required: true, message: '请输入备注信息!' }] }-->
              <a-input  type="textarea" style="width: 580px;margin-left: 6px;" v-decorator="['baseRemark', ]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="padding-top: 10px">
          <a-col :span="10"></a-col>
          <a-col :span="6">
            <a-button type="primary" @click="completeTemplate">
              完成
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-form>
  </a-modal>

</template>
<script>
  import {
    getDictMap
  } from "../../../utils/dict"
  import {
    getfindByMenuId,
    getsavetemplate
  } from '@/api/finance/modifyDefaultTemplate'
  import pick from 'lodash.pick'
  export default {
    data() {
      return {
        checkedList: [],
        modifyible: false,
        innerFirst: false,
        leftfindId: [],
        rightfindId: [],
        targetKeys: '',
        templatedatatargetKeys: '',
        targetSelectedKey: '',
        templatedatargetSelectedKey: '',
        form: this.$form.createForm(this),
        plainOptions: [],
        restaurantOperTypeMap: [],
        statement_template_data: [],
        findByMenuId: [],
        InternalByMenuId: [],
        checkboxindex: '',
        checkedleftlist: [],
        checkedrightlist: [],
        indeterminate: true,
        checkAll: false,
        plainOption: ['Apple', 'Pear', 'Orange'],
        statementrightlist: '',
        value: '',
        innerReceivers: [],
        templatelist: '',
        statement_template_sort: [],
      };
    },

    methods: {
      empty() {
        this.value = ''
      },
      onChangeradio(e) {
        console.log('radio checked', e.target.value);
      },
      innerFirstonChange(e) {
        this.innerFirst = e.target.checked

      },
      singleonChange(i){
        this.InternalByMenuId[i].checked=!this.InternalByMenuId[i].checked


      },
      async showcreated() {

        // 内部
        getfindByMenuId({
          menuId: '2559',
          userType: '00'
        }).then(res => {
           for (var i = 0; i < res.length; i++) {

             if (this.templatelist.marketPrincipalId == res[i].userId) {
               res[i].checked = true
             }else {
               res[i].checked = false
             }
             // if(this.innerReceivers){
             if(this.innerReceivers.length>0){
               for(var j=0;j<this.innerReceivers.length;j++){
                 if(this.innerReceivers[j]!=this.templatelist.marketPrincipalId&&this.innerReceivers[j]==res[i].userId){
                   res[i].checked = true
                 }
               }
             }

         }

          this.InternalByMenuId = res;
          //console.log('vvvv',this.InternalByMenuId,res)

        })
        this.statement_template_data = [];
        this.restaurantOperTypeMap = await getDictMap('statement_template_data');
        this.restaurantOperTypeMap.forEach((value, key) => {
          this.statement_template_data.push({
            key: key,
            title: value
          })
        })
        // 字典为分单方式
        this.plainOptions = [];
        this.restaurantOperTypeMap = await getDictMap('seperate_order_method');
        this.restaurantOperTypeMap.forEach((value, key) => {
          this.plainOptions.push({
            key: key,
            title: value
          })
        })
        // 字典为分单方式
        this.statement_template_sort = [];
        this.restaurantOperTypeMap = await getDictMap('statement_template_sort');
        this.restaurantOperTypeMap.forEach((value, key) => {
          // this.plainOptions.push({value: key, label: value})
          this.statement_template_sort.push({
            key: key,
            title: value
          })
        })
      },
      // 回显
      showmodify(templatelist) {
       // console.log('templatelist',templatelist)
        this.modifyible = true
        this.form.resetFields()
        this.showcreated()
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(templatelist,
            'seperateRemark', 'dataRemark', 'receiverRemark', 'baseRemark'))
        })
        this.templatelist = templatelist
        // 外部
        getfindByMenuId({
          menuId: '2826',
          userType: '22',
          enterpriseId: this.templatelist.enterpriseId
        }).then(res => {
          this.leftfindId = res
          let that = this
          this.rightfindId.forEach(tab => {
            that.leftfindId = that.leftfindId.filter((item) => tab.userId != item.userId);
          })
           //console.log(this.leftfindId, this.rightfindId)
        })
        if (templatelist.dataTemplateStrList) {
          this.templatedatatargetKeys = templatelist.dataTemplateStrList
        } else {
          this.templatedatatargetKeys = ['']
        }
        if (templatelist.infoTemplateStrList) {
          this.targetKeys = templatelist.infoTemplateStrList
        } else {
          this.targetKeys = ['']
        }
        this.innerFirst = templatelist.innerFirst == 1 ? 'true' : 'false'
        if (templatelist.outerReceivers) {
          this.rightfindId = templatelist.outerReceivers
        } else {
          this.targetKeys = ['']
        }
        //console.log('templatelist.checkedList',templatelist)
        if(templatelist.innerReceiverIds){
          this.innerReceivers = templatelist.innerReceiverIds
        }else {
          this.innerReceivers=[]
        }



        this.value = templatelist.seperateMethod
      },
      onChangegroup(checkedValues) {
        this.checkedList = checkedValues
      },
      // 完成按钮
      completeTemplate() {
        this.form.validateFields((err, values) => {
          for (let i = 0; i <= this.templatedatatargetKeys.length; i++) {
            if (this.templatedatatargetKeys[this.templatedatatargetKeys.length] == '') {
              values.dataTemplateStrList = this.templatedatatargetKeys.slice(0, this.templatedatatargetKeys.length -
                1)
            } else {
              values.dataTemplateStrList = this.templatedatatargetKeys
            }
          }
          for (let i = 0; i <= this.targetKeys.length; i++) {
            if (this.targetKeys[this.targetKeys.length] == '') {
              values.infoTemplateStrList = this.targetKeys.slice(0, this.targetKeys.length - 1)
            } else {
              values.infoTemplateStrList = this.targetKeys
            }
          }
          values.innerFirst = this.innerFirst == true ? '1' : '0'
          values.outerReceivers = this.rightfindId
          var newarrying=[]
          for (var i = 0; i < this.InternalByMenuId.length; i++) {
            if (this.InternalByMenuId[i].checked) {
              newarrying.push(this.InternalByMenuId[i].userId)
            }
          }
          this.checkedList=newarrying
          values.innerReceiverIds = this.checkedList
          values.seperateMethod = this.value
          values.enterpriseId = this.templatelist.enterpriseId
          console.log(values)
          if (!err) {
            getsavetemplate(values).then(res => {
              if (res.code === 0) {
                this.modifyible = false
                this.innerReceivers = []
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      onChange(checkedList) {
        this.indeterminate = !!checkedList.length && checkedList.length < this.plainOption.length;
        this.checkAll = checkedList.length === this.plainOption.length;
      },
      // 外部接受人 向左
      shiftLeft() {
        console.log(this.rightfindId, this.checkedleftlist)
        this.rightfindId = [...this.rightfindId, ...this.checkedleftlist]
        let that = this
        this.checkedleftlist.forEach(tab => {
          that.leftfindId = that.leftfindId.filter((item) => tab != item);
        })
        this.checkedleftlist = []
      },
      // 外部接受人 向右
      shiftRight() {
        this.leftfindId = [...this.leftfindId, ...this.checkedrightlist]
        let that = this
        this.checkedrightlist.forEach(tab => {
          that.rightfindId = that.rightfindId.filter((item) => tab != item);
        })
        this.checkedrightlist = []


      },
      onChangecheckbox(index, e) {
        if (e.target.checked) {
          
          let bool = this.checkedleftlist.includes(this.leftfindId[index])
          // console.log(bool,'bool')
          if (!bool) {
            this.checkedleftlist.push(this.leftfindId[index])
          }
          // console.log(this.checkedleftlist,'选中')
        }
      },
      onChangeright(index) {
        if(this.rightfindId[index].userId!=this.templatelist.marketPrincipalId){
          this.rightfindId[index].checked=!this.rightfindId[index].checked
          console.log('this.rightfindId[index].checked',this.rightfindId[index].checked)
          if (this.rightfindId[index].checked) {
            let bool = this.checkedrightlist.includes(this.rightfindId[index])
            if (!bool) {
              this.checkedrightlist.push(this.rightfindId[index])
            }
            // console.log(this.checkedrightlist)
          }
        }
      },
      onChangeinput(index, e) {
        this.leftfindId[index].roleName = e.target.value
        // console.log(this.leftfindId);
      },
      up(type) {
        if (type == 'statement') {
          let index = this.targetKeys.indexOf(this.targetSelectedKey)
          if (index != -1 && index != 0) {
            [this.targetKeys[index - 1], this.targetKeys[index]] = [this.targetKeys[index],
              this.targetKeys[index - 1]
            ]
          }
          let keys = []
          this.targetKeys.forEach(key => keys.push(key))
          this.targetKeys = keys
        }
        if (type == 'templatedata') {
          let index = this.templatedatatargetKeys.indexOf(this.templatedatargetSelectedKey)
          if (index != -1 && index != 0) {
            [this.templatedatatargetKeys[index - 1], this.templatedatatargetKeys[index]] = [this.templatedatatargetKeys[
                index],
              this.templatedatatargetKeys[index - 1]
            ]
          }
          let keys = []
          this.templatedatatargetKeys.forEach(key => keys.push(key))
          this.templatedatatargetKeys = keys
        }
      },
      down(type) {
        if (type == 'statement') {
          let index = this.targetKeys.indexOf(this.targetSelectedKey)
          if (index != -1 && index != this.targetKeys.length - 1) {
            [this.targetKeys[index + 1], this.targetKeys[index]] = [this.targetKeys[index],
              this.targetKeys[index + 1]
            ]
          }
          let keys = []
          this.targetKeys.forEach(key => keys.push(key))
          this.targetKeys = keys
        }
        if (type == 'templatedata') {
          let index = this.templatedatatargetKeys.indexOf(this.templatedatargetSelectedKey)
          if (index != -1 && index != this.templatedatatargetKeys.length - 1) {
            [this.templatedatatargetKeys[index + 1], this.templatedatatargetKeys[index]] = [this.templatedatatargetKeys[
                index],
              this.templatedatatargetKeys[index + 1]
            ]
          }
          let keys = []
          this.templatedatatargetKeys.forEach(key => keys.push(key))
          this.templatedatatargetKeys = keys
        }
      },
      templatedatahandleChange(nextTargetKeys, direction, moveKeys) {
        this.templatedatatargetKeys = nextTargetKeys;
      },
      statementhandleChange(nextTargetKeys, direction, moveKeys) {
        this.targetKeys = nextTargetKeys;
      },
      statementhandleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.targetSelectedKey = targetSelectedKeys[0]

      },
      templatedahandleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.templatedatargetSelectedKey = targetSelectedKeys[0]
      },
    },
    async created() {

    }
  };
</script>
<style>
  * {
    padding: 0;
    margin: 0;
  }

  .transfer-content {
    display: inline-block;
    position: relative;
    line-height: 1.5;
  }

  li {
    list-style: none;
    cursor: pointer;
    position: relative;
  }

  .selection-container {
    height: 282px;
  }

  .select-box {
    width: 180px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    display: inline-block;
    font-size: 12px;
    left: 15px;
    height: 283px;
    position: relative;
    float: left;
  }

  .arrows-box {
    float: left;
    display: inline-block;
    position: relative;
    line-height: 1.5;
    top: 35%;
  }

  .select-content {
    width: 100%;
    overflow: hidden;
    height: 86%;
  }

  .select-box-title {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-family: "微软雅黑";
    padding: 0 6%;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    background: #f9fafc;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
    color: #000;
  }

  /*.checkbox-all{
  float:left;
  }*/
  .select-box-title label:before {
    left: -14px !important;
    top: 4px !important;
  }

  .select-box-title label:after {
    left: -10px !important;
    top: 5px !important;
  }

  .checkboxs {
    vertical-align: middle;
  }

  .unselect-ul {
    padding: 8px 0 10px 0;
    overflow: auto;
    height: 87%;
  }

  .selected-ul {
    padding: 8px 0 10px 0;
    overflow: auto;
    height: 87%;
  }

  .select-content li {
    padding: 5px 15px;
    font-size: 12px;
    font-family: "微软雅黑";
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* .select-content .ivu-input{ */
  /* border-radius: 0% !important; */
  /* border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px; */
  /* } */
  .select-content .ivu-input-icon {
    line-height: 29px;
    right: 2px;
  }

  .select-content .ivu-input-wrapper {
    padding: 5px 8px 0px;
  }

  .select-content .ivu-input {
    height: 29px;
  }

  .select-box input[type='checkbox'] {
    position: absolute;
    left: 13px;
    top: 9px;
    width: 20px;
    height: 20px;
    opacity: 0;
  }

  .select-box label {
    position: absolute;
    left: 30px;
    top: 12px;
    height: 20px;
    line-height: 20px;
  }

  .select-box span {
    padding-left: 34px;
    white-space: nowrap;
  }

  .select-box label:before {
    content: '';
    position: absolute;
    left: -14px;
    top: -3px;
    width: 16px;
    height: 16px;
    border: 1px solid #ddd;
    border-radius: 2px;
    transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    background-color: #fff;
  }

  .select-box label:after {
    content: '';
    position: absolute;
    left: -8px;
    top: 0px;
    width: 4px;
    height: 8px;
    border: 2px solid #fff;
    background: #fff;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg) scale(1);
    transition: all .2s ease-in-out;
    cursor: pointer;
  }

  .select-box .select-box-title label:after {
    content: '';
    position: absolute;
    left: -8px !important;
    top: 7px !important;
    width: 4px;
    height: 8px;
    border: 0;
    border: 2px solid #fff;
    border-top: 0;
    border-left: 0;
    background: #fff;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
  }

  .select-box input[type='checkbox']:checked+label:before {
    background: #03a4ad;
    border-color: #03a4ad;
    cursor: pointer;
  }

  .select-box input[type='checkbox']:checked+label:after {
    background: #03a4ad;
    cursor: pointer;
  }

  .arrow-btns {
    display: inline-block;
    margin: 0px 3px 0px 40px;
    min-width: 24px;
  }

  .btn-cursor {
    background-color: #409eff !important;
    border: 1px solid #409EFF !important;
    transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
  }

  .btn-cursor svg {
    fill: #fff !important;
    transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
  }

  /*.btn-cursor{
  cursor: not-allowed !important;
  }*/
  .arrow-btn {
    display: block;
    position: relative;
    width: 40px;
    height: 31px;
    background: #eee;
    margin: 0 auto 5px;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    outline: none;
    border-radius: 3px;
    color: #c5c8ce;
    background-color: #f7f7f7;
    border-color: #dcdee2;
  }

  .arrow-btn svg {
    padding: 11px;
    width: 17px;
    height: 17px;
    color: white;
    fill: #C0C4CC;
  }

  .leftArrow:before {
    content: "\F115";
    font-size: 14px;
    color: #d9dde7;
    display: inline-block;
    font-family: Ionicons;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    vertical-align: middle;
  }

  .rightArrow:before {
    content: "\F11F";
    font-size: 14px;
    color: #d9dde7;
    display: inline-block;
    font-family: Ionicons;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    vertical-align: middle;
  }

  .topArrow:before {
    content: "\F124";
    font-size: 14px;
    color: #ccd0d8;
    display: inline-block;
    font-family: Ionicons;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    vertical-align: middle;
    cursor: not-allowed;
  }

  .downArrow:before {
    content: "\F116";
    font-size: 14px;
    color: #ccd0d8;
    display: inline-block;
    font-family: Ionicons;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    vertical-align: middle;
  }

  .top {
    cursor: not-allowed !important;
  }

  .bottom {
    cursor: not-allowed !important;
  }

  #leftBtn {
    margin-bottom: 12px;
  }

  .lable-all {
    top: 7px !important;
  }

  .title {
    padding-left: 39px !important;
  }

  .totalCount {
    max-width: 16px;
    padding: 0 !important;
    margin-left: 36px;
  }

  .emptyTip {
    text-align: center;
    color: #c5c8ce;
    font-size: 14px !important;
    display: none;
  }

  .unemptyTip {
    text-align: center;
    color: #c5c8ce;
    font-size: 14px !important;
    display: none;
  }

   /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>
